export default "__VITE_ASSET__209tb$_A__"